import { axios } from '@/utils/request'

/**
 *
 * @param parameter
 * @returns {*}
 */

// 历史数据查询接口
export function getNewestRealTimeData (parameter) {
  return axios({
    url: '/environmentMonitorServer/getNewestRealTimeData',
    method: 'get',
    params: parameter
  })
}

export function ByCollectTime (parameter) {
    return axios({
      url: '/environmentMonitorServer/getEnvironmentalMonitorEntityByCollectTime',
      method: 'get',
      params: parameter
    })
  }

//初始话筛选框
export function initScreenData (parameter) {
  return axios({
    url: '/environmentMonitorServer/initScreenData',
    method: 'get',
    params: parameter
  })
}